// extracted by mini-css-extract-plugin
module.exports = {"container":"HorizontalNav_container__WVvS-","small":"HorizontalNav_small__3IsKX","large":"HorizontalNav_large__3r8AO","selected":"HorizontalNav_selected__2Q7nk"};